import styled from 'styled-components';
import { Typography } from '@agilepoint/wat-react-ux';
import { DropdownField, ToggleInputField } from '@agilepoint/wat-react-ux-form-fields';
import { GridLayout } from 'common';

const StyledGrid = styled(GridLayout)`
    padding-right: 40px;
    height: 100%;
`;

const MenuOptionsWrapper = styled.div`
    width: 665px;
    height: calc(100% - 157px);
    background-color: ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant6};
    border-radius: 6px;
    padding: 30px 0px 30px 40px;
    box-sizing: border-box;
`;

const StyledToggledInput = styled(ToggleInputField)`
    margin-left: 20px;
`;

const StyledText = styled(Typography.H5)`
    margin-right: 50px;
`;

const LocaleDropdownField = styled(DropdownField)`
    width: 326px;
`;

export { StyledGrid, MenuOptionsWrapper, StyledToggledInput, StyledText, LocaleDropdownField };
